/*
 * rheincool — zentrales Event-Tracking (HANDOFF.md §14)
 * Alle Module melden über window.rcTrack(event, params).
 * Ziel: dataLayer (GTM/Custom Pixel) + DOM-Event 'rc:track' für Erweiterungen.
 * Kein Event enthält personenbezogene Daten.
 */
(() => {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  window.rcTrack = (event, params = {}) => {
    if (!event) return;
    const payload = { event, ...params };
    try {
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('rc:track', { detail: payload }));
    } catch (error) {
      // Tracking darf nie die Seite brechen
      console.warn('[rc-track]', error);
    }
  };

  // Deklaratives Tracking: <a data-rc-track="consult_cta_click" data-rc-track-quelle="header">
  document.addEventListener('click', (clickEvent) => {
    const el = clickEvent.target.closest('[data-rc-track]');
    if (!el) return;
    const params = {};
    Object.entries(el.dataset).forEach(([key, value]) => {
      if (key.startsWith('rcTrack') && key !== 'rcTrack') {
        const paramName = key.slice('rcTrack'.length).toLowerCase();
        params[paramName] = value;
      }
    });
    window.rcTrack(el.dataset.rcTrack, params);
  });
})();
